import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import { Prompt, withRouter } from "react-router";
import classnames from "classnames";
import { toast } from "react-toastify";
import { UsaStates } from "usa-states";

import * as actions from "../../../../store/actions";
import constants from "../../../../constants";
import {
  REMOVE_VALIDATIONS,
  VALIDATE_DOCUMENTS,
} from "../../../../store/actions/actionTypes";
import { getOnboardingPath } from "../../../../constants";

import Button from "../../../../components/formElements/button/Button";
import TextInput from "../../../../components/formElements/input/TextInput";
import Row from "../../../../components/uiElements/grid/Row";
import Card from "../../../../layout/Onboarding/Card";
import DateTimePicker from "../../../../components/formElements/datepicker/DateTimePicker";
import Col from "../../../../components/uiElements/grid/Col";
import FileInput from "../../../../components/formElements/file/FileInput";
import OnboardingIcon from "../../../../components/uiElements/icons/onboardingIcons/OnboardingIcon";
import SelectInput from "../../../../components/formElements/selectInput/SelectInput";

const StepThree = ({
  documents,
  setDocuments,
  updateDoctorDocuments,
  validateData,
  removeValidations,
  redirectedPath,
  deleteFileFromS3,
  form,
  history,
}) => {
  const onFileError = error => {
    toast.error(error, {
      position: constants.TOAST_POSITION,
    });
  };

  const myRef = useRef();

  useEffect(() => {
    if (form && form.documentsValid) {
      if (redirectedPath || (documents.dataLoaded && documents.dataChanged)) {
        updateDoctorDocuments(
          "update",
          () =>
            documents.dataLoaded &&
            documents.dataChanged &&
            history.push(getOnboardingPath("/uplaodsignature"))
        );
      } else {
        updateDoctorDocuments("save", () => {
          history.push(getOnboardingPath("/uplaodsignature"));
        });
      }
    } else if (form.documentsValid === false) {
      myRef?.current?.querySelector(":invalid")?.scrollIntoView({
        behavior: "smooth",
      });
    }
    form.documentsValid = false;
    toast.error(form.documents, {
      position: constants.TOAST_POSITION,
    });
    form.documents = false;
    // eslint-disable-next-line
  }, [form]);

  useEffect(() => {
    redirectedPath && setDocuments({ dataChanged: false });
    redirectedPath && setDocuments(documents.copy);
    removeValidations();
    // eslint-disable-next-line
  }, []);

  const skillStyles = {
    multiValue: styles => {
      return {
        ...styles,
        background: "var(--pallet-color)",
      };
    },
    multiValueLabel: styles => ({
      ...styles,
      color: "white",
    }),
    multiValueRemove: styles => ({
      ...styles,
      color: "white",
      ":hover": {
        backgroundColor: "transparent",
      },
    }),
    placeholder: styles => ({
      ...styles,
      color: "#bbc1d0",
    }),
    dropdownIndicator: styles => ({
      ...styles,
      paddingRight: 25,
      display: "inline",
    }),
  };

  return (
    <>
      {redirectedPath && (
        <Prompt
          when={documents.dataChanged}
          message="You have unsaved changes, are you sure you want to leave?"
        />
      )}
      <div
        ref={myRef}
        className={classnames(
          "onboarding-container"
          // documents.dataLoaded && !redirectedPath && "disable"
        )}
      >
        <p className="onboarding-header">Documents</p>
        <Row>
          <Card>
            <TextInput
              error={form.npiNumber}
              type="number"
              maxLength={10}
              label="NPI Number"
              value={documents.npiNumber}
              onChange={val => setDocuments({ npiNumber: val })}
            />
          </Card>
          <Card title="License Details">
            <Row className="mb-5 mt-n3">
              <Col size={["md-12"]}>
                <FileInput
                  showPreview
                  buttonClass="w-100 "
                  name="licenseDoc"
                  files={documents.licenseDoc}
                  onChange={files => setDocuments(files)}
                  onError={error => onFileError(error)}
                  onRemove={file =>
                    deleteFileFromS3(file, () =>
                      updateDoctorDocuments("update")
                    )
                  }
                />
              </Col>
              <Col size={["md-12"]} className="mt-4 mb-n4">
                <TextInput
                  error={form.licenseNumber}
                  type="number"
                  maxLength={6}
                  label="License Number"
                  value={documents.licenseNumber}
                  onChange={val => setDocuments({ licenseNumber: val })}
                />
              </Col>

              <Col size={["md-12"]} className="mt-n2">
                <SelectInput
                  error={form.licenseState}
                  isSearchable
                  menuPlacement="auto"
                  options={new UsaStates().states.map(state => ({
                    label: state.name,
                    value: state.abbreviation,
                  }))}
                  placeholder="Select State"
                  styles={skillStyles}
                  value={documents.licenseState}
                  onChange={val => setDocuments({ licenseState: val })}
                />
              </Col>

              <Col size={["md-12"]} className="mt-3">
                <DateTimePicker
                  mode="date"
                  type="document"
                  placeholder="Start Date"
                  value={documents.licenseStartDate}
                  onChange={val => setDocuments({ licenseStartDate: val })}
                />
              </Col>
              <Col size={["md-12"]} className="col-sm-12">
                <DateTimePicker
                  mode="date"
                  type="document"
                  id="endDate"
                  sDate={documents?.licenseStartDate}
                  placeholder="End Date"
                  value={documents.licenseEndDate}
                  onChange={val => setDocuments({ licenseEndDate: val })}
                />
              </Col>
            </Row>
          </Card>

          <Card title="DEA Details">
            <Row className="mb-5 mt-n3">
              <Col size={["md-12"]}>
                <FileInput
                  showPreview
                  buttonClass="w-100 "
                  name="deaDoc"
                  files={documents.deaDoc}
                  onChange={files => setDocuments(files)}
                  onError={error => onFileError(error)}
                  onRemove={file =>
                    deleteFileFromS3(file, () =>
                      updateDoctorDocuments("update")
                    )
                  }
                />
              </Col>
              <Col size={["md-12"]} className="mt-4 mb-n5">
                <TextInput
                  error={form.deaNumber}
                  type="text"
                  maxLength={9}
                  label="DEA Number"
                  value={documents.deaNumber}
                  onChange={val => setDocuments({ deaNumber: val })}
                />
              </Col>
              <Col size={["md-12"]} className="mt-3">
                <SelectInput
                  error={form.deaState}
                  isSearchable
                  menuPlacement="auto"
                  options={new UsaStates().states.map(state => ({
                    label: state.name,
                    value: state.abbreviation,
                  }))}
                  placeholder="Select State"
                  styles={skillStyles}
                  value={documents.deaState}
                  onChange={val => setDocuments({ deaState: val })}
                />
              </Col>
              <Col size={["md-12"]} className="mt-3">
                <DateTimePicker
                  mode="date"
                  type="document"
                  placeholder="Start Date"
                  value={documents.deaStartDate}
                  onChange={val => setDocuments({ deaStartDate: val })}
                />
              </Col>
              <Col size={["md-12"]}>
                <DateTimePicker
                  mode="date"
                  type="document"
                  id="endDate"
                  sDate={documents?.deaStartDate}
                  placeholder="End Date"
                  value={documents.deaEndDate}
                  onChange={val => setDocuments({ deaEndDate: val })}
                />
              </Col>
            </Row>
          </Card>
          <Card title="Insurance Details">
            <Row className="mb-5 mt-n3">
              <Col size={["md-12"]}>
                <FileInput
                  showPreview
                  buttonClass="w-100 "
                  name="insuranceDoc"
                  files={documents.insuranceDoc}
                  onChange={files => setDocuments(files)}
                  onError={error => onFileError(error)}
                  onRemove={file =>
                    deleteFileFromS3(file, () =>
                      updateDoctorDocuments("update")
                    )
                  }
                />
              </Col>
              <Col size={["md-12"]} className="mt-4 mb-n3">
                <TextInput
                  error={form.insuranceCompanyName}
                  type="text"
                  label="Company Name"
                  value={documents.insuranceCompanyName}
                  onChange={val => setDocuments({ insuranceCompanyName: val })}
                />
              </Col>
              <Col size={["md-12"]} className="mt-n3">
                <SelectInput
                  error={form.insuranceState}
                  isSearchable
                  menuPlacement="auto"
                  options={new UsaStates().states.map(state => ({
                    label: state.name,
                    value: state.abbreviation,
                  }))}
                  placeholder="Select State"
                  styles={skillStyles}
                  value={documents.insuranceState}
                  onChange={val => setDocuments({ insuranceState: val })}
                />
              </Col>
              <Col size={["md-12"]} className="mt-3">
                <DateTimePicker
                  mode="date"
                  type="document"
                  placeholder="Start Date"
                  value={documents.insuranceStartDate}
                  onChange={val => setDocuments({ insuranceStartDate: val })}
                />
              </Col>
              <Col size={["md-12"]}>
                <DateTimePicker
                  mode="date"
                  type="document"
                  id="endDate"
                  sDate={documents?.insuranceStartDate}
                  placeholder="End Date"
                  value={documents.insuranceEndDate}
                  onChange={val => setDocuments({ insuranceEndDate: val })}
                />
              </Col>
            </Row>
          </Card>
          {!redirectedPath ? (
            <Button
              type="secondary"
              indicatorButton
              className={classnames(
                "float-right next-button",
                documents.dataLoaded && "enable"
              )}
              onClick={() =>
                documents.dataLoaded && !documents.dataChanged
                  ? history.push(getOnboardingPath("/uplaodsignature"))
                  : validateData(documents)
              }
              label={<OnboardingIcon type="nextButton" />}
            />
          ) : (
            <Button
              type="info"
              disabled={!documents.dataChanged && true}
              className={classnames("w-75 mx-auto mb-4")}
              onClick={() => validateData(documents)}
              label={"Save Changes"}
            />
          )}
        </Row>
      </div>
    </>
  );
};

const mapStoreToProps = ({ onboarding, validation, auth }) => ({
  documents: onboarding.documents,
  form: validation.data,
  redirectedPath: auth.redirectToOnboardingPath,
});

const mapDispatchToProps = dispatch => ({
  setDocuments: updatedData => dispatch(actions.setDocuments(updatedData)),
  updateDoctorDocuments: (action, cb) =>
    dispatch(actions.updateDoctorDocuments(action, cb)),
  deleteFileFromS3: (file, cb) => dispatch(actions.deleteFileFromS3(file, cb)),
  validateData: documentsData =>
    dispatch(actions.validateData(VALIDATE_DOCUMENTS, documentsData)),
  removeValidations: () =>
    dispatch(actions.validateData(REMOVE_VALIDATIONS, {})),
});

export default withRouter(
  connect(mapStoreToProps, mapDispatchToProps)(StepThree)
);
